import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import {
  formatBadgeLabel,
  getBadgeBaseStyle,
  getBadgeLabelStyle,
  getBadgeShape,
  getBadgeToneStyle,
  normalizeBadgeTone,
} from "../badgeStyles";

const useStyles = makeStyles({
  root: {
    boxSizing: "border-box",
  },
  label: ({ shape }) => ({
    ...getBadgeLabelStyle({ shape }),
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
});

const CcBadge = ({
  tone = "neutral",
  pill = false,
  shape,
  uppercase = false,
  className,
  classes: chipClasses,
  children,
  label,
  style,
  ...props
}) => {
  const resolvedTone = normalizeBadgeTone(tone);
  const resolvedShape = getBadgeShape({ shape, pill, tone: resolvedTone });
  const toneStyle = getBadgeToneStyle(resolvedTone);
  const shouldUppercase = uppercase || resolvedShape === "label";
  const displayLabel = formatBadgeLabel(label ?? children, shouldUppercase);
  const classes = useStyles({ shape: resolvedShape });

  return (
    <Chip
      classes={{
        ...chipClasses,
        root: [chipClasses?.root, classes.root].filter(Boolean).join(" "),
        label: [chipClasses?.label, classes.label].filter(Boolean).join(" "),
      }}
      className={className}
      label={displayLabel}
      size="small"
      style={{
        ...getBadgeBaseStyle({
          shape: resolvedShape,
          uppercase: shouldUppercase,
        }),
        backgroundColor: toneStyle.background,
        color: toneStyle.color,
        ...style,
      }}
      {...props}
    />
  );
};

export default CcBadge;
